import { packageVersion as alertUiVersion } from '@juvare/alert-ui';
import { commonFormUiVersion } from '@juvare/common-form-ui';
import { commonPhoneNumberVersion } from '@juvare/common-phone-number';
import { commonWebUiVersion } from '@juvare/common-web-ui';
import { contactManagementVersion } from '@juvare/contact-management';
import { dataImportUiVersion } from '@juvare/data-import-ui';
import { documentLibraryVersion } from '@juvare/document-library';
import { packageVersion as platformAppVersion } from '@juvare/platform-app';
import { platformCliVersion } from '@juvare/platform-cli';
import { packageVersion } from '@juvare/platform-sdk-js';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const DependenciesVersionsTable: React.FC = () => {
    const { t } = useTranslation();
    const [alertUiServerVersion, setAlertUiServerVersion] = React.useState('');
    const [platformServerVersion, setPlatformServerVersion] = React.useState('');

    React.useEffect(() => {
        fetch('/platform/proxy/notify/alert/version')
            .then((response) => {
                if (response.ok) {
                    response
                        .text()
                        .then((version) => setAlertUiServerVersion(version))
                        .catch(console.error);
                }
            })
            .catch(console.error);
    }, []);

    React.useEffect(() => {
        fetch('/platform/api/v1/management/health')
            .then((response) => {
                if (response.ok) {
                    response
                        .json()
                        .then((json) => setPlatformServerVersion(json.version))
                        .catch(console.error);
                }
            })
            .catch(console.error);
    }, []);

    return (
        <Table size='small'>
            <TableHead>
                <TableRow>
                    <TableCell>{t('panels.home.moduleName')}</TableCell>
                    <TableCell>{t('panels.home.version')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>@juvare/health-alerts</TableCell>
                    <TableCell>{window.appVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/common-form-ui</TableCell>
                    <TableCell>{commonFormUiVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/common-phone-number</TableCell>
                    <TableCell>{commonPhoneNumberVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/common-web-ui</TableCell>
                    <TableCell>{commonWebUiVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/alert-ui</TableCell>
                    <TableCell>{alertUiVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/contact-management</TableCell>
                    <TableCell>{contactManagementVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/data-import-ui</TableCell>
                    <TableCell>{dataImportUiVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/document-library</TableCell>
                    <TableCell>{documentLibraryVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/platform-app</TableCell>
                    <TableCell>{platformAppVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/platform-sdk-js</TableCell>
                    <TableCell>{packageVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>@juvare/platform-cli</TableCell>
                    <TableCell>{platformCliVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>alert-service</TableCell>
                    <TableCell>{alertUiServerVersion}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>platform-server</TableCell>
                    <TableCell>{platformServerVersion}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};
